import { useEffect, useState } from "react";
import ProjectUtils from "../../../../../../utils/project-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

export default function IndividualWithMoreEncounters({ data }) {
    const individualWithMoreEncountersData = data?.individualsWithMoreEncounters ?? [];
    const [limit, setLimit] = useState(15);

    const passedLimit = individualWithMoreEncountersData.length > 15;

    const seeMoreOrLess = () => {
        setLimit((prevState) => (prevState ? null : 15));
    };

    useEffect(() => {
        ReportUtils.createExportableTable(
            null,
            null,
            "Indivíduos com recorrência",
            "individual-with-more-encounters-export-table"
        );
    }, [individualWithMoreEncountersData]);

    const renderNotInfo = (value) => {
        if (!value || value === "Não informado") {
            return <span className="text-[#8F8F8F] italic">{value || "Não informado"}</span>;
        }

        return value;
    }

    return (
        <>
            <span className="chart-title">
                Indivíduos com recorrência em abordagens {passedLimit && limit ? "(TOP 15)" : ""}
            </span>

            <table
                id="individual-with-more-encounters-table"
                className="table report-table mt-3"
            >
                <thead className="thead-background print:table-row-group!">
                <tr className="bg-[#f6f6f6] text-left">
                    <th className="w-[20%]">Qtd.</th>
                    <th className="w-[50%]">Nome</th>
                    <th className="w-[30%]">CPF</th>
                </tr>
                </thead>

                <tbody className="bg-white">
                {(limit
                        ? individualWithMoreEncountersData.slice(0, limit)
                        : individualWithMoreEncountersData
                ).map((element, index) => (
                    <tr key={index} className="table-break-word">
                        <td>{element.qty ?? 0}</td>
                        <td>{renderNotInfo(element.name)}</td>
                        <td>
                            {element.cpf && element.cpf !== "Não informado"
                                ? ProjectUtils.formatCpfToView(element.cpf)
                                : renderNotInfo(element.cpf)}
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>

            {passedLimit && (
                <div className="text-end mt-1">
                    <span
                        className="see-more print-hide cursor-pointer"
                        onClick={seeMoreOrLess}
                    >
                        {limit ? "Ver mais" : "Ver menos"}
                    </span>
                </div>
            )}

            <table
                id="individual-with-more-encounters-export-table"
                className="hidden"
                sheet-name="Indivíduos com recorrência em abordagens"
            >
                <thead>
                <tr>
                    <th>Qtd.</th>
                    <th>Nome</th>
                    <th>CPF</th>
                </tr>
                </thead>
                <tbody>
                {individualWithMoreEncountersData.map((element, index) => (
                    <tr key={index}>
                        <td>{element.qty ?? 0}</td>
                        <td>{element.name ?? "Não informado"}</td>
                        <td>
                            {element.cpf
                                ? ProjectUtils.formatCpfToView(element.cpf)
                                : "Não informado"}
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>

            <div id="chart-tables" />
            <div className="chart-divisor" />
        </>
    );
}